export function postStatusClassName(status: string) {
  if (status.includes('review')) return 'review';
  if (status.includes('working')) return 'ready';
  if (status === 'Scheduled') return 'scheduled';
  if (status === 'Published') return 'published';
  if (status.includes('input')) return 'input';
  if (status.includes('Stopped')) return 'stopped';
  return 'planned';
}

export function postStatusIconName(status: string) {
  const statusCategory = postStatusClassName(status);
  if (statusCategory === 'review') return 'FiAlertCircle';
  if (statusCategory === 'published') return 'FiCheckCircle';
  if (statusCategory === 'stopped') return 'FiPauseCircle';
  if (statusCategory === 'input') return 'FiHelpCircle';
  return 'FiClock';
}
